// extracted by mini-css-extract-plugin
export default {"summary":"TaskProjectIssueActionPage_summary__+EK22","title":"TaskProjectIssueActionPage_title__0PkU7"};